<template>
  <md-card v-if="bookings.length">
    <md-card-header>
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <h4 class="title">Historic Bookings</h4>
        </div>
      </div>
    </md-card-header>
    <md-card-content>
      <div class="md-layout-item md-small-size-100 md-size-100">
        <time-line plain type="simple" id="booking_timeline">
          <time-line-item
            inverted
            badge-type="warning"
            badge-icon="event_available"
            v-for="booking in bookings"
            :key="booking.id"
          >
            <div class="md-layout" slot="header">
              <div class="md-layout-item md-size-60">
                <i class="fas fa-clock text-primary"></i>
                {{ booking.booking_date | formatDate }}
              </div>
              <div
                class="md-layout-item md-size-40 text-right"
                style="align-items:flex-start"
              >
                <span class="badge badge-success"
                  >Booking ID: <strong>{{ booking.id }}</strong></span
                >
              </div>
            </div>
            <div class="md-layout md-alignment-bottom-left" slot="content">
              <div class="md-layout-item md-size-60 booking-summary">
                <ul>
                  <li>
                    <span>ROLE : </span
                    ><span>{{ bookerStatus(booking.lead_booker_id) }}</span>
                  </li>
                  <li>
                    <span>TOUR : </span
                    ><router-link
                      v-if="booking.tour"
                      :to="{
                        name: 'Adventure Profile',
                        params: { tour_id: booking.tour.id }
                      }"
                    >
                      {{ booking.tour.title }}</router-link
                    >
                    <span v-else>UNKNOWN</span>
                  </li>
                  <li>
                    <span>DEPARTURE : </span>
                    <span>{{ booking.departure_date | formatDate }}</span>
                  </li>
                  <li>
                    <span>TRAVELLERS : </span>
                    <span>{{ booking.travellers_count }}</span>
                  </li>
                  <li>
                    <span>AMOUNT : </span>
                    <span class="text-success"
                      >{{ booking.booking_total }}
                      {{
                        booking.currency ? booking.currency.toUpperCase() : ""
                      }}</span
                    >
                  </li>
                </ul>
              </div>
            </div>
          </time-line-item>
        </time-line>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import customerApi from "@/services/api/customer";
import { TimeLine, TimeLineItem } from "@/components";

export default {
  props: ["customer"],

  data() {
    return {
      bookings: []
    };
  },

  components: {
    TimeLine,
    TimeLineItem
  },

  methods: {
    getBookings() {
      customerApi.getHistoricBookings(this.customer).then(resp => {
        this.bookings = resp.data;
      });
    },

    bookerStatus(userId) {
      return userId == this.customer.id ? "Lead Booker" : "Traveller";
    }
  },

  mounted() {
    this.getBookings();
  }
};
</script>

<style lang="scss"></style>
<style lang="scss" scoped>
h6 {
  margin-bottom: 1rem;
}
</style>
